import Services from './base-services'

const service = new Services('metaDataCategory')

export default {
    getMetaDataCategoryStudent: () => {
        return service.post('getMetaDataCategoryStudent');
    },
}
